import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { analysisPath } from "./scenarioRailItems";

/** Old `jobs/:jobId` links showed the result on the closure page; it is on Analysis now. */
const LegacyJobRedirect: React.FC = () => {
  const { jobId = "" } = useParams<{ jobId: string }>();
  return <Navigate to={analysisPath(jobId)} replace />;
};

export default LegacyJobRedirect;
